import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { breakpoint } from "src/library/utils/styled-media-queries/index";

const InfoBarWrapperStyled = styled(Grid.Box)`
  ${({ theme }) => css`
    align-self: flex-start;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 500px;

    ${breakpoint("lg", theme)} {
      margin-left: ${({ theme }) => theme.spacing.margins.lg};
    }
  `}
  `;

const InfoBarWrapper: React.ReactFCWithChildren = props => {
  return (
    <InfoBarWrapperStyled
      className="info-bar-wrapper"
      {...props}
      shiftRight
    />
  );
};

export default InfoBarWrapper;
